import TableComponent from "app/common/Component/Table/TableComponent";
import { useStore } from "app/stores";
import React, { memo, useState } from "react";
import { Grid, IconButton, Menu, MenuItem, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  formatMoney,
  formatNumber,
  getDateTime,
  isAdmin,
  isDoctor,
  isRoleHisReadOnly,
} from "app/common/LocalFunction";
import IconPen from "app/common/Icon/IconPen";
import { observer } from "mobx-react";
import IconDelete from "app/common/Icon/IconDelete";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import HistoryIcon from "@material-ui/icons/History";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { LockSharp } from "@material-ui/icons";
import { ACTIVE_STATUS, LOCKED_STATUS } from "app/common/LocalConst";
const ListRegisterService = ({ setSelectedRows }) => {
  const { t } = useTranslation();
  const {
    handleChangeFormSearchService,
    pageRegisterService,
    searchRegisterService,
    handleOpenCreateOrEditServicePopup,
    handleOpenConfirmDelete,
    setSelectedRowService,
    setSelectRegisterServiceId,
    handleOpenRegisterServiceHistoryPopup,
  } = useStore().patientManagementStore.registerServiceStore;

  const isDocters = isDoctor();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isReadonly = isRoleHisReadOnly();
  const [anchorEl, setAnchorEl] = useState(null);
      const [selectedRow, setSelectedRow] = useState(null);
       const handleMenuOpen = (event, rowData) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(rowData);
      };
    
      const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedRow(null);
      };
  return (
    <Grid
      container
      spacing={1}
      className="justify-center cards-body pt-0 mt-2"
      style={{
        zIndex: 1,
        position: "relative",
      }}
    >
      <Grid item xs={12}>
        <TableComponent
          showOrdinalNumbers
          titleNodata={t("noData")}
          selectType={!isMobile && !isReadonly ? "multi" : undefined}
          handleChangeSelectedRows={(selectedItems) => {
            setSelectedRowService(selectedItems);
          }}
          data={pageRegisterService?.content || []}
          minWidth={"720px"}
          maxHeight={"460px"}
          name="ListRegisterService"
          showMoreButton
          columns={[
            !isReadonly && {
              title: t("action"),
              field: "action",
              align: "center",
              width: "70px",
              render: (row) => (
                // <div className="flex-center gap-2">
                //   {!isReadonly && (
                //     <>
                //       <Tooltip
                //         title={
                //           row?.activeStatus === 2
                //             ? "Dịch vụ đã bị khóa - không thể chỉnh sửa"
                //             : "Chỉnh sửa"
                //         }
                //       >
                //         <div
                //           onClick={
                //             row?.activeStatus !== 2
                //               ? () => handleOpenCreateOrEditServicePopup(row)
                //               : undefined
                //           }
                //           style={{
                //             cursor:
                //               row?.activeStatus === 2
                //                 ? "not-allowed"
                //                 : "pointer",
                //             opacity: row?.activeStatus === 2 ? 0.5 : 1,
                //           }}
                //         >
                //           <IconPen />
                //         </div>
                //       </Tooltip>
                //     </>
                //   )}

                //   {(!isDocters || isAdmin) && !isReadonly && (
                //     <Tooltip
                //       title={
                //         row?.activeStatus === 2
                //           ? "Dịch vụ đã bị khóa - không thể xóa"
                //           : "Xóa"
                //       }
                //     >
                //       <div
                //         className="flex"
                //         onClick={
                //           row?.activeStatus !== 2
                //             ? () => handleOpenConfirmDelete(row?.id)
                //             : undefined
                //         }
                //         style={{
                //           cursor:
                //             row?.activeStatus === 2 ? "not-allowed" : "pointer",
                //           opacity: row?.activeStatus === 2 ? 0.5 : 1,
                //         }}
                //       >
                //         <IconDelete />
                //       </div>
                //     </Tooltip>
                //   )}
                //   <Tooltip title={"Lịch sử"}>
                //     <div
                //       className="flex"
                //       onClick={() => {
                //         setSelectRegisterServiceId(row?.id);
                //         handleOpenRegisterServiceHistoryPopup(); // <- thêm dấu ngoặc để gọi hàm
                //       }}
                //     >
                //       <HistoryIcon />
                //     </div>
                //   </Tooltip>
                //   {/* <Tooltip
                //     title="In bản ghi"
                //     onClick={() => {
                //       setSelectedRowService(row);
                //       setOpenPopupPrintService(true);
                //     }}
                //   >
                //     <div className="flex">
                //       <PrintIcon />
                //     </div>
                //   </Tooltip> */}
                // </div>
                <>
                  <div className="flex-center gap-2 cursor">
                    <Tooltip
                      title={
                        row?.activeStatus === LOCKED_STATUS
                          ? "Dịch vụ đã bị khóa - không thể chỉnh sửa"
                          : "Chỉnh sửa"
                      }
                    >
                      <div
                        onClick={
                          row?.activeStatus !== 2
                            ? () => handleOpenCreateOrEditServicePopup(row)
                            : undefined
                        }
                        style={{
                          cursor:
                            row?.activeStatus === LOCKED_STATUS
                              ? "not-allowed"
                              : "pointer",
                          opacity: row?.activeStatus === LOCKED_STATUS ? 0.5 : 1,
                        }}
                      >
                        <IconPen />
                      </div>
                    </Tooltip>
                    {(!isDocters || isAdmin) && !isReadonly && (
                      <Tooltip
                        title={
                          row?.activeStatus === LOCKED_STATUS
                            ? "Dịch vụ đã bị khóa - không thể xóa"
                            : "Xóa"
                        }
                      >
                        <div
                          className="flex"
                          onClick={
                            row?.activeStatus !== 2
                              ? () => handleOpenConfirmDelete(row?.id)
                              : undefined
                          }
                          style={{
                            cursor:
                              row?.activeStatus === LOCKED_STATUS ? "not-allowed" : "pointer",
                            opacity: row?.activeStatus === LOCKED_STATUS ? 0.5 : 1,
                          }}
                        >
                          <IconDelete />
                        </div>
                      </Tooltip>
                    )}
                    <Tooltip title="Tùy chọn">
                      <IconButton
                        size="small"
                        onClick={(e) => handleMenuOpen(e, row)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                  <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl) && selectedRow?.id === row?.id}
                    onClose={handleMenuClose}
                    PaperProps={{
                      style: {
                        boxShadow: "none", 
                      },
                    }}
                  >
                    <MenuItem >
                      <Tooltip title={"Lịch sử"}>
                        <div
                          style={{display:"flex", gap:"10px", alignItems:"center"}}
                          onClick={() => {
                            setSelectRegisterServiceId(row?.id);
                            handleOpenRegisterServiceHistoryPopup();  // <- thêm dấu ngoặc để gọi hàm
                            handleMenuClose()
                          }}
                        >
                          <HistoryIcon />
                          <span>Lịch sử</span>
                        </div>
                      </Tooltip>
                    </MenuItem>
                  </Menu>
                </>
              ),
            },
            {
              field: "service.tradeName",
              title: t("Dịch vụ"),
              render: (row) => {
                let percent =
                  (+row?.totalPerformedTimes * 100) /
                    +row?.totalTreatmentTimes || 0;
                return (
                  <div className="pl-1 pr-1">
                    <div
                      onClick={
                        !isReadonly
                          ? () => handleOpenCreateOrEditServicePopup(row)
                          : undefined
                      }
                    >
                      <span className="service-code">{row?.service?.code}</span>{" "}
                      <span className="service-name">
                        {row?.service?.tradeName}
                      </span>
                    </div>
                    <div class="fancy-progress-wrapper mt-1">
                      <div class="fancy-progress-text">
                        {row?.totalPerformedTimes} | {row?.totalTreatmentTimes}
                      </div>
                      <div class="fancy-progress-bar">
                        <div
                          class="fancy-progress-fill"
                          style={{ width: `${percent}%` }}
                        ></div>
                      </div>
                    </div>
                    <div className="flex mt-2">
                      <div>
                        Đã thu:{" "}
                        <b style={{ color: "green" }}>
                          {formatMoney(row?.totalBillPatientPaid || 0)}
                        </b>
                      </div>
                      <span className="mx-2 text-gray-400">|</span>
                      <div>
                        Cần thu:{" "}
                        <b style={{ color: "red" }}>
                          {formatMoney(row?.amountActuallyPaid)}
                        </b>
                      </div>
                    </div>
                  </div>
                );
              },
            },
            {
              field: "practitioner.staffName",
              title: t("Giá"),
              render: (row) => formatMoney(row?.price),
              align: "right",
            },
            {
              field: "quantity",
              title: t("Số lượng"),
              align: "right",
            },
            {
              field: "practitioner.staffName",
              title: t("Thành tiền"),
              width: "240px",
              render: (data) => {
                return (
                  <div className="total-data-group">
                    <div className="flex justify-between">
                      Thành tiền:{" "}
                      <b>{formatMoney(data?.price * data?.quantity)}</b>
                    </div>
                    <div className="flex justify-between">
                      Giảm giá: <b>{formatMoney(data?.discount)}</b>
                    </div>

                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Số tiền (sau giảm):{" "}
                        <b>
                          {formatMoney(
                            data?.price * data?.quantity -
                              (+data?.discount || 0)
                          )}
                        </b>
                      </b>
                    </div>
                    <div className="flex justify-between">
                      Vat: <b>{formatMoney(+data?.taxTotal)}</b>
                    </div>
                    <div
                      style={{
                        background: "#ccc",
                        width: "100%",
                        height: "1px",
                        margin: "4px 0",
                      }}
                    ></div>
                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Tổng thanh toán:{" "}
                        <b>{formatMoney(+data?.amountActuallyPaid || 0)}</b>
                      </b>
                    </div>
                    {data?.allocateDiscount ? (
                      <div>
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Giảm tổng HĐ:{" "}
                          <b>{formatMoney(data?.allocateDiscount)}</b>
                        </b>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                );
              },
            },
            {
              field: "clientCard.name",
              title: t("Ngày đăng ký"),
              render: (val) => getDateTime(val?.orderDate),
            },
            {
              field: "clientCard.name",
              title: t("Doanh thu phân bổ(nhân viên)"),
              render: (val) => {
                return (
                  <>
                    {val?.staffRevenues?.map((staffRevenue, index) => (
                      <div key={index} className="revenue-item">
                        <span className="revenue-percent">
                          {staffRevenue?.source?.name} -{" "}
                        </span>
                        <span className="position">
                          {" "}
                          {staffRevenue?.position?.name} -{" "}
                        </span>
                        <b className="staff-name">
                          {staffRevenue?.staff?.staffName}
                        </b>
                        <i className="revenue-percent">
                          {staffRevenue?.actualAmount && (
                            <span className="label-primary-number">
                              {formatMoney(staffRevenue?.actualAmount)}
                              {"-"}
                            </span>
                          )}
                          {formatNumber(staffRevenue?.percentRevenue) + "%"}
                        </i>
                      </div>
                    ))}
                  </>
                );
              },
            },

            {
              field: "createdBy",
              title: t("Người tạo"),
            },
            {
              field: "modifiedBy",
              title: t("Người sửa"),
            },
            {
              field: "department.name",
              title: t("Cơ sở"),
            },

            {
              field: "activeStatus",
              title: t("Trạng thái"),
              render: (row) => (
                <div style={{ textAlign: "center" }}>
                  {row?.activeStatus === ACTIVE_STATUS ? (
                    <Tooltip title="Đang mở">
                      <LockOpenIcon />
                    </Tooltip>
                  ) : row?.activeStatus === LOCKED_STATUS ? (
                    <Tooltip title="Đã khóa">
                      <LockIcon />
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </div>
              ),
            },
            {
              field: "note",
              title: t("Ghi chú"),
            },
          ].filter(Boolean)}
          dataPagination={{
            pageIndex: searchRegisterService?.pageIndex,
            pageSize: searchRegisterService?.pageSize,
            totalElements: pageRegisterService?.totalElements,
            totalPages: pageRegisterService?.totalPages,
            setPageIndex: (pageIndex) =>
              handleChangeFormSearchService({ pageIndex }),
            setPageSize: (pageSize) =>
              handleChangeFormSearchService({ pageSize }),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default memo(observer(ListRegisterService));
